import React from "react";
import {
  disabledColor,
  mainColor,
  subColor1,
  subColor2,
  textColor,
  whiteColor,
} from "../assets/colors/color";
import { format, isSameDay, parseISO } from "date-fns";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function ListItem({ data, NextPageType }) {
  console.log(data.shippingWorkStartAt);
  console.log(data);

  const startDate = parseISO(data.shippingWorkStartAt);

  const data123 = format(startDate, "yyyy_MM_dd_HH:mm");

  const time = format(startDate, "HH:mm");

  const state = {
    idJourney: data.idJourney,
    journeyDetailId: data.journeyDetailId,
    shippingWorkStartAt: data.shippingWorkStartAt,
    shipName: data.ship, //배이름
    shipType: data.shipType, //배 타입
    status: data.status, //배 단계
    voyageNumber: data.voyageNumber, //항차
    charterer: data.charterer,
    cargo: data.cargo,
  };
  console.log("List Box Data: ", state);

  const navigate = useNavigate();

  const navigateToPurchase = () => {
    if (NextPageType === "UserShipLog") {
      //user-작업일지
      data.shipType === "운송"
        ? navigate("/user-ship-log-transit", {
            state: state,
          })
        : data.shipType === "기선STS"
        ? navigate("/user-ship-log-steamship", {
            state: state,
          })
        : data.shipType === "순찰"
        ? navigate("/user-ship-log-patrol", {
            state: state,
          })
        : navigate("/user-ship-log");
    } else if (NextPageType === "ManagerShipLogFix") {
      //manager - 작업일지수정단계
      data.shipType === "운송"
        ? navigate("/manager-ship-log-transitFix", {
            state: state,
          })
        : data.shipType === "기선STS"
        ? navigate("/manager-ship-log-steamshipFix", {
            state: state,
          })
        : data.shipType === "순찰"
        ? navigate("/manager-ship-log-patrolFix", {
            state: state,
          })
        : navigate("/manager-ship-log");
    } else {
      navigate(null);
    }
  };

  //엑셀파일 다운로드
  const handelXlsx = () => {
    axios({
      method: "GET",
      url: `/api/excel/generate/journey?journeyDetailId=${data.journeyDetailId}&jobType=${data.jobType}`,
      responseType: "blob",
      // 구글링 해보니 responseType을 꼭 추가하라고 했다.
    }).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: res.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${data123}-${data.ship}작업일지운송.xls`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            fontWeight: 700,
            paddingTop: 10,
            paddingRight: 10,
            borderRight: `2px solid ${disabledColor}`,
          }}
        >
          {time}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginLeft: 10,
          }}
        >
          <div
            onClick={navigateToPurchase}
            style={
              data.shipType === "운송" && NextPageType === "ManagerShipLogFix"
                ? {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    width: "100%",
                    padding: "15px 20px",
                    backgroundColor: `${mainColor}`,
                    borderRadius: "10px 10px 0 0",
                    color: `${whiteColor}`,
                  }
                : data.shipType === "운송"
                ? {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    width: "100%",
                    padding: "15px 20px",
                    backgroundColor: `${mainColor}`,
                    borderRadius: "10px",
                    color: `${whiteColor}`,
                  }
                : data.shipType === "기선STS"
                ? {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    width: "100%",
                    padding: "15px 20px",
                    backgroundColor: `${subColor1}`,
                    borderRadius: "10px",
                    color: `${whiteColor}`,
                  }
                : data.shipType === "순찰"
                ? {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    width: "100%",
                    padding: "15px 20px",
                    backgroundColor: `${subColor2}`,
                    borderRadius: "10px",
                    color: `${whiteColor}`,
                  }
                : {}
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1 style={{ fontWeight: 500, fontSize: 17 }}>{data.ship}</h1>
              <span
                style={{
                  borderRadius: 999,
                  border: `2px solid`,
                  padding: 5,
                  fontWeight: 700,
                  fontSize: 15,
                }}
              >
                {data.status}
              </span>
            </div>
            <p style={{ marginTop: 6 }}>
              <span>항차 : </span>
              <span>{data.voyageNumber}</span>
            </p>
            <p>
              <span>구분 : </span>
              <span>
                {data.shipType === data.jobType
                  ? data.shipType
                  : `${data.shipType} / ${data.jobType}`}
              </span>
            </p>
            {data.shipType === "운송" || data.shipType === "기선STS" ? (
              <div>
                <p>
                  <span>용선주 : </span>
                  <span>{data.charterer}</span>
                </p>
                <p style={{ marginTop: 6 }}>
                  <span>화물 : </span>
                  <span>{data.cargo}</span>
                </p>
              </div>
            ) : null}
          </div>
          {data.shipType === "운송" && NextPageType === "ManagerShipLogFix" ? (
            <div
              onClick={handelXlsx}
              style={{
                padding: 10,
                textAlign: "center",
                borderRadius: "0 0 10px 10px",
                border: `2px solid ${textColor}`,
                borderTop: "none",
                color: `${textColor}`,
                fontWeight: 700,
              }}
            >
              작업일지 엑셀 다운로드
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}

function ListBox({ edata, selectedDate, NextPageType }) {
  console.log(edata);
  const SelectSameDate =
    edata &&
    edata.filter((data) =>
      isSameDay(parseISO(data.shippingWorkStartAt), selectedDate)
    );

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        padding: 10,
        fontSize: "15px",
        fontWeight: 400,
      }}
    >
      {SelectSameDate && SelectSameDate.length > 0 ? (
        SelectSameDate.map((data) => (
          <ListItem
            data={data}
            key={data.idJourney}
            NextPageType={NextPageType}
          />
        ))
      ) : (
        <h1
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 24,
          }}
        >
          일정이 없습니다.
        </h1>
      )}
    </div>
  );
}

export default ListBox;
